import { AgentMark } from './agent-mark.component';
import { useAssistantStore } from './use-assistant-store';

/** Topbar trigger that toggles the EOS Assistant slide-over. */
export function AssistantButton() {
  const isOpen = useAssistantStore((state) => state.isOpen);
  const toggle = useAssistantStore((state) => state.toggle);

  return (
    <button
      type="button"
      className={`eos-asst-trigger${isOpen ? ' is-open' : ''}`}
      aria-haspopup="dialog"
      aria-expanded={isOpen}
      aria-label="EOS Assistent"
      title="EOS Assistent"
      onClick={toggle}
    >
      <AgentMark />
    </button>
  );
}
